import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-theme-provider-essent-light',
  standalone: true,
  styleUrl: './theme-provider-essent-light.component.scss',
  template: '<ng-content />',
})
export class ThemeProviderEssentLightComponent {}
